import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';
import { _x } from '@wordpress/i18n';

const zeroPad = (number) => (number < 10 ? '0' + number : number);

const a11yConfig = {
  firstSlideMessage: _x(
    'This is the first slide',
    'carousel first slide label',
    'vtx'
  ),
  lastSlideMessage: _x(
    'This is the last slide',
    'carousel last slide label',
    'vtx'
  ),
  paginationBulletMessage: _x(
    'Go to slide {{index}}',
    'carousel navigation label',
    'vtx'
  ),
  prevSlideMessage: _x('Previous slide', 'carousel previous label', 'vtx'),
  nextSlideMessage: _x('Next slide', 'carousel next label', 'vtx'),
};

const fractionPagination = (containerEl) => ({
  el: containerEl.querySelector('.swiper-pagination'),
  type: 'fraction',
  formatFractionCurrent: zeroPad,
  formatFractionTotal: zeroPad,
});

domReady(() => {
  document.querySelectorAll('.ptc-slider-block').forEach((block) => {
    const variant = block.dataset.variant;

    if ('text-image' === variant || 'text-quote' === variant) {
      // Variants A & C: two synchronized carousels
      const textEl = block.querySelector('.ptc-slider-block__text-swiper');
      const mediaEl = block.querySelector('.ptc-slider-block__media-swiper');
      const controlsEl = block.querySelector(
        '.ptc-slider-block__content .ptc-slider-block__controls'
      );

      if (!textEl || !mediaEl) {
        return;
      }

      const mediaSwiper = new Swiper(mediaEl, {
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        rewind: true,
        allowTouchMove: false,
        a11y: a11yConfig,
      });

      new Swiper(textEl, {
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        rewind: true,
        controller: {
          control: mediaSwiper,
        },
        navigation: {
          prevEl: controlsEl
            ? controlsEl.querySelector('.swiper-button-prev')
            : null,
          nextEl: controlsEl
            ? controlsEl.querySelector('.swiper-button-next')
            : null,
        },
        pagination: controlsEl ? fractionPagination(controlsEl) : false,
        a11y: a11yConfig,
      });
    } else if ('static-carousel' === variant) {
      // Variant B: single carousel — controls are inside each slide overlay
      const mediaEl = block.querySelector('.ptc-slider-block__media-swiper');

      if (!mediaEl) {
        return;
      }

      const updateVariantBPagination = (swiper) => {
        mediaEl.querySelectorAll('.swiper-pagination').forEach((el) => {
          el.textContent = `${zeroPad(swiper.realIndex + 1)} / ${zeroPad(
            swiper.slides.length
          )}`;
        });
      };

      const swiper = new Swiper(mediaEl, {
        slidesPerView: 1,
        rewind: true,
        a11y: a11yConfig,
        on: {
          init: updateVariantBPagination,
          slideChange: updateVariantBPagination,
        },
      });

      mediaEl.addEventListener('click', (e) => {
        if (e.target.closest('.swiper-button-prev')) swiper.slidePrev();
        if (e.target.closest('.swiper-button-next')) swiper.slideNext();
      });
    } else if (
      'static-text-carousel' === variant ||
      'static-image-carousel' === variant
    ) {
      // Variants D & E: text-only carousel with controls on top
      const mediaEl = block.querySelector('.ptc-slider-block__media-swiper');
      const controlsEl = block.querySelector(
        '.ptc-slider-block__media .ptc-slider-block__controls'
      );

      if (!mediaEl) {
        return;
      }

      new Swiper(mediaEl, {
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        rewind: true,
        navigation: {
          prevEl: controlsEl
            ? controlsEl.querySelector('.swiper-button-prev')
            : null,
          nextEl: controlsEl
            ? controlsEl.querySelector('.swiper-button-next')
            : null,
        },
        pagination: controlsEl ? fractionPagination(controlsEl) : false,
        a11y: a11yConfig,
      });
    }
  });
});
